import React, { Component } from 'react';
import './index.css';

class CircleLoader extends Component{
	constructor(props){
		super(props);
		this.state = {
			
		}			
	}
	
	
	render(){
		return(
			<div className="cloader"></div>
		);
	}
	
}
export default CircleLoader;